  import React, { useEffect, useState } from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faSearch } from "@fortawesome/free-solid-svg-icons";
  import { FaDownload, FaEye, FaShareAlt } from "react-icons/fa"; // Import the edit icon
  import axios from "axios";
  import Grid from "../components/Grid"; // Import the Grid component
  import { DataGrid } from "@mui/x-data-grid";
  import { toast } from "react-toastify";
  import { downloadStockOverview } from "../components/fetchLatestOrderCycle";
  import { saveAs } from "file-saver";
  import ExcelJS from "exceljs";

  // Use the environment variable for the API base URL
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function OrderCycle({ onAddOrderCycleClick }) {
  const [ordercycle, setOrderCycle] = useState([])
  const [selectedOrderCycle, setSelectedOrderCycle] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [customers, setCustomers] = useState([]) // List of all customers
  const [selectedCustomers, setSelectedCustomers] = useState([]) // Selected customers
  const [selectedSearchField, setSelectedSearchField] = useState("orderCycleCode") // New state for search field
  const [sort] = useState({ field: "orderCycleCode", direction: "asc" })
  const [userRole, setUserRole] = useState("") // State to store user role
  const [isEdited, setIsEdited] = useState(false)
  const [selectAll, setSelectAll] = useState(false) // Track select all status
  const [organizationContactNo, setOrganizationContactNo] = useState("") // State to store organization contact number
  const [organizationContactName, setOrganizationContactName] = useState("")

    // Fetch order cycle and locations
    useEffect(() => {
      // Fetch the logged-in user's role
      const fetchUserRole = async () => {
        try {
          const token = sessionStorage.getItem("token");
          if (!token) {
            toast.error("Authentication token is missing. Please log in again.");
            return;
          }

          const response = await axios.get(`${API_BASE_URL}/users/specific`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          setUserRole(response.data.role);
        } catch (error) {
          console.error("Error fetching user role:", error);
          toast.error("Error fetching user role");
        }
      };

      const fetchOrderCycle = async () => {
        try {
          const token = sessionStorage.getItem("token");
          if (!token) {
            toast.error("Authentication token is missing. Please log in again.");
            return;
          }
      
          const response = await axios.get(
            `${API_BASE_URL}/orders/order-cycle/get-all-order-cycles`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
      
      
          let orderCycles = response.data.orderCycles || [];
      
          // Sort by createdAt (or orderdate if createdAt doesn't exist)
          orderCycles.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
          );
      
          const ordercycleWithId = orderCycles.map((ordercycle) => ({
            ...ordercycle,
            id: ordercycle.orderCycleCode,
            createdDate: ordercycle.createdDate,
            selectedProductionBatches: ordercycle.selectedProductionBatches || [],
            whatsappname: ordercycle.organization.whatsapp_calling_name || "",
            orderdate: ordercycle.orderdate
              ? new Date(ordercycle.orderdate).toISOString().split("T")[0]
              : "",
            deliveryDate: ordercycle.deliveryDate
              ? new Date(ordercycle.deliveryDate).toISOString().split("T")[0]
              : "",
          }));
      
      
          setOrderCycle(ordercycleWithId);
        } catch (error) {
          console.error("Error fetching order cycles:", error);
          toast.error("Error fetching order cycles");
        }
      };
      
      const fetchCustomers = async () => {
        try {
          const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage
          if (!token) {
            toast.error("Authentication token is missing. Please log in again.");
            return;
          }
          const response = await axios.get(
            `${API_BASE_URL}/customers`,
            {
              headers: {
                Authorization: `Bearer ${token}`, // Include token in Authorization header
              },
            }
          );
          setCustomers(
            response.data.customers.map((customer) => ({
              ...customer,
              id: customer.customer_code,
            }))
          );
        } catch (error) {
          console.error("Error fetching customers:", error);
          toast.error("Error fetching customers");
        }
      };

      fetchOrderCycle();
      fetchCustomers();
      fetchUserRole();
      fetchOrganizationSettings();
    }, []);

    useEffect(() => {
      if (selectedOrderCycle) {
        document.body.style.overflow = "hidden"; // Disable background scroll
      } else {
        document.body.style.overflow = "auto"; // Re-enable background scroll
      }

      return () => {
        document.body.style.overflow = "auto"; // Reset on unmount
      };
    }, [selectedOrderCycle]);

    //fetch organization details
    const fetchOrganizationSettings = async () => {
            try {
              const token = sessionStorage.getItem("token");
              if (!token) {
                toast.error("Authentication token is missing. Please log in again.");
                return;
              }
        
              const response = await axios.get(`${API_BASE_URL}/organizations/getSettings`, {
                headers: { Authorization: `Bearer ${token}` },
              });
        
              setOrganizationContactNo(response.data.contact_number);
              setOrganizationContactName(response.data.contact_name);
            } catch (error) {
              toast.error("Error fetching organization settings.");
            }
          };

    const handleOrderCycleClick = (orderCycle) => {
      if (!orderCycle || !Array.isArray(orderCycle.products)) {
        console.error("Invalid order cycle data", orderCycle);
        return;
      }
    
      const formattedProducts = orderCycle.products.map((product) => ({
        id: product.product?._id || product.product_code || "N/A", // Use product ID or code as fallback
        product_code: product.product?.product_code || "N/A",
        product_image: product.product?.product_image || "No Image",
        product_name: product.product?.product_name || "Unknown",
        unit: product.product?.unit?.unit_name,
        aggregatedQuantity: product.aggregatedQuantity || 0,
        latestPrice: product.latestPrice
          ? parseFloat(product.latestPrice.$numberDecimal || product.latestPrice)
          : 0, // Handle Decimal128
      }));
    
      setSelectedOrderCycle({
        ...orderCycle,
        products: formattedProducts,
        whatsapp_calling_name: orderCycle.organization?.whatsapp_calling_name || "",
        location: orderCycle.location?.location_name || "",
        createdBy: orderCycle.createdBy?.username || "N/A",
        createdDate: orderCycle.createdDate || "",
        status: orderCycle.status || "Active",
      });

    setIsEdited(false)
  }

  const handleCustomerSelection = (e, customer) => {
    if (e.target.checked) {
      const newSelectedCustomers = [...selectedCustomers, customer]
      setSelectedCustomers(newSelectedCustomers)
      // Check if all customers are now selected
      if (newSelectedCustomers.length === customers.length) {
        setSelectAll(true)
      }
    } else {
      const newSelectedCustomers = selectedCustomers.filter((c) => c.customer_code !== customer.customer_code)
      setSelectedCustomers(newSelectedCustomers)
      setSelectAll(false)
    }
  }

  const handleSelectAll = () => {
    if (selectAll) {
      // Deselect all
      setSelectedCustomers([])
      setSelectAll(false)
    } else {
      // Select all
      setSelectedCustomers([...customers])
      setSelectAll(true)
    }
  }

    // New state for customer selection popup
    const [showCustomerSelectionPopup, setShowCustomerSelectionPopup] =
      useState(false);

    const handleShareClick = (orderCycle) => {

      try{

        if (orderCycle.status === "Inactive") {
          toast.error("This order cycle is not active and cannot be shared.");
          return;
        }else if(orderCycle.status === "Closed"){
          toast.error("This order cycle is Closed and cannot be shared.");
          return; 
        }else{
          setSelectedOrderCycle(orderCycle); // Set selected order cycle here
          setShowCustomerSelectionPopup(true); // Show the customer selection popup
        }
      }catch(error){
        console.error("Error in Share button click:", error);
        toast.error("An unexpected error occurred. Please try again.");
      }

      
    };

    const handleSendClick = async () => {
      if (selectedCustomers.length === 0) {
        toast.warn(
          "Please select at least one customer to share the order cycle."
        );
        return;
      }
    
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }
    
        for (const customer of selectedCustomers) {
          if (!customer.cus_mobileno) {
            toast.warn(
              `Customer ${customer.customer_name} has no valid mobile number.`
            );
            continue;
          }
    
          // Fetch the shortened URL from the backend, now including the phone number
          const response = await axios.get(
            `${API_BASE_URL}/orders/order-cycle/generate-order-cycle-link/${
              selectedOrderCycle.orderCycleCode
            }?customerName=${encodeURIComponent(
              customer.customer_name
            )}&phoneNumber=${encodeURIComponent(customer.cus_mobileno)}&customerId=${encodeURIComponent(customer._id)}`, // Add phone number to query params
            { headers: { Authorization: `Bearer ${token}` } }
          );
    
          const shortLink = response.data?.orderRequestLink;
    
          if (!shortLink) {
            toast.error(
              `Failed to generate order link for ${customer.customer_name}`
            );
            continue;
          }
    
          // Send the WhatsApp message
          const whatsappResponse = await axios.post(
            `${API_BASE_URL}/sendwhatsapp/sendwhatsapp`,
            {
              phoneNumber: customer.cus_mobileno,
              customer_name: customer.customer_name,
              selectedOrderCycleDescription: selectedOrderCycle.organization.whatsapp_calling_name,
              orderdate: selectedOrderCycle.orderdate,
              deliveryDate: selectedOrderCycle.deliveryDate,
              shortLink: shortLink,
              organizationContactNumber: organizationContactNo, // Use the fetched organization contact number
              organizationContactName: organizationContactName,
              messageType: "orderCycle", // Add messageType to the request body
            }
          );

    
          if (whatsappResponse.data.success) {
            toast.success(
              `Message sent successfully to ${customer.customer_name}`
            );
          } else {
            toast.error(`Failed to send message to ${customer.customer_name}`);
          }
        }
    
        setShowCustomerSelectionPopup(false);
        setSelectedCustomers([]);
        setSelectedOrderCycle(null);
      } catch (error) {
        console.error("Error sending messages:", error);
        toast.error("An unexpected error occurred. Please try again.");
      }
    }; 

  const handleCloseCustomerSelectionPopup = () => {
    setShowCustomerSelectionPopup(false);
    setSelectedCustomers([]);
    setSelectedOrderCycle(null);
    setSelectAll(false); // Reset select all state
  };

    const handleClosePopup = () => {
      setSelectedOrderCycle(null);
    };

    const handleUpdateOrderCycle = async (orderCycleId, description, status, deliveryDate, orderdate) => {
      try {
          const token = sessionStorage.getItem("token");
          if (!token) {
              toast.error("Authentication token is missing. Please log in again.");
              return;
          }


          if (deliveryDate && orderdate && new Date(deliveryDate) < new Date(orderdate)) {
            toast.error("Order date cannot be later than delivery date.");
            return;
          }

          // Sending updated data to the server
          await axios.put(
              `${API_BASE_URL}/orders/update-order-cycle/${orderCycleId}`,
              { description, status, deliveryDate, orderdate },
              {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
              }
          );
          toast.success("Order Cycle Updated Successfully");

        try {
          const updatedOrderCycles = await axios.get(`${API_BASE_URL}/orders/order-cycle/get-all-order-cycles`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          });


        const ordercycleWithId = updatedOrderCycles.data.orderCycles.map((ordercycle) => ({
          ...ordercycle,
          id: ordercycle.orderCycleCode,
          selectedProductionBatches: ordercycle.selectedProductionBatches || [], // Ensure default value
        }))

        setOrderCycle(ordercycleWithId)
      } catch (error) {
        console.error("Error Rereeving order cycle:", error.response?.data || error.message)
        toast.error(error.response?.data?.message || "Error Updating Order Cycle")
      }
    } catch (error) {
      console.error("Error updating order cycle:", error.response?.data || error.message)
      toast.error(error.response?.data?.message || "Error Rereeving Order Cycle")
    }
  }

      // Additional function to handle input changes
      const handleInputChange = (field, value) => {
        setSelectedOrderCycle((prev) => ({
          ...prev,
          [field]: value
        }));
        setIsEdited(true); // Set isEdited to true as the user has made an edit
      };

      const filteredOrderCycles = ordercycle
        .filter((cycle) => {
          switch (selectedSearchField) {
            case "orderCycleCode":
              return cycle.orderCycleCode?.toLowerCase().includes(searchTerm.toLowerCase());
            case "description":
              return cycle.description?.toLowerCase().includes(searchTerm.toLowerCase());
            case "createdBy":
              return cycle.createdBy?.username?.toLowerCase().includes(searchTerm.toLowerCase());
            case "location":
              return cycle.location?.location_name?.toLowerCase().includes(searchTerm.toLowerCase()) || false;
            case "orderdate":
              return cycle.orderdate?.toLowerCase().includes(searchTerm.toLowerCase());
            case "deliveryDate":
              return cycle.deliveryDate?.toLowerCase().includes(searchTerm.toLowerCase());  
            case "status":
              return cycle.status?.toLowerCase().includes(searchTerm.toLowerCase());
            default:
              return true;
          }
        })
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)) // Sort by latest created first
      

    const columns = [
      { field: "id", headerName: "ID", flex: 1 }, // Use id here
      {
        field: "createdDate",
        headerName: "Created Date",
        flex: 1,
        renderCell: (params) => (
          <span>
            {params.value ? new Date(params.value).toLocaleDateString("en-GB") : "N/A"}
          </span>
        ),
      },
      {
        field: "description",
        headerName: "Description",
        flex: 1,
      },
      {
        field: "location",
        headerName: "Location",
        flex: 1,
        renderCell: (params) => (
          <span>
            {params.row.location ? params.row.location.location_name : "N/A"}
          </span>
        ),
      },
      {
        field: "orderdate",
        headerName: "Order Date",
        flex: 1,
      },
      {
        field: "deliveryDate",
        headerName: "Delivery Date",
        flex: 1,
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
        renderCell: (params) => {
          const status = params.row.status;
          let statusClass = "bg-gray-400 text-white"; // Default color
    
          if (status === "Active") {
            statusClass = "bg-[#388E3C] text-white"; 
          } else if (status === "Inactive") {
            statusClass = "bg-[#E57373] text-white"; 
          } else if (status === "Closed") {
            statusClass = "bg-[#B0BEC5] text-white"; 
          }
    
          return (
            <span className={`px-2 py-1 rounded-sm ${statusClass}`}>
              {status}
            </span>
          );
        },
      },
      {
        field: "types",
        headerName: "Created By",
        flex: 1,
        renderCell: (params) => (
          <span>
            {params.row.createdBy ? params.row.createdBy.username : "N/A"}
          </span>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
          <div className="flex  items-center gap-2 w-full h-full">
            {" "}
            {/* gap-2 adds space between elements */}
            <button
              onClick={() => handleOrderCycleClick(params.row)}
              className="bg-[#FBC02D] text-white p-2 flex items-center "
              style={{ width: "30px", height: "30px" }}
            >
              <FaEye className="text-white" />
            </button>
            <button
              onClick={() => handleShareClick(params.row)}
              className="bg-[#8BC34A] text-white p-2 flex items-center "
              style={{ width: "30px", height: "30px" }}
            >
              <FaShareAlt className="text-white" />
            </button>
            <button
              onClick={() => downloadStockOverview(params.row)}  // Pass the clicked row to generate PDF
              className="bg-green-500 text-white p-2 flex items-center"
              style={{ width: "30px", height: "30px" }}
            >
              <FaDownload className="text-white" />
            </button>
          </div>
        ),
      },
    ];


    const formatDateISO = (dateString) => {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? "N/A" : date.toISOString().split("T")[0];
    };

    const handleDownloadExcel = async () => {
        const dataToExport =
          searchTerm.trim().length > 0 ? filteredOrderCycles : ordercycle;

        if (dataToExport.length === 0) {
          toast.warn("No order cycle data to export.");
          return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Order Cycles");

        const headerRow = [
          "Order Cycle Code",
          "Description",
          "Location",
          "Created By",
          "Order Date",
          "Delivery Date",
          "Created Date",
          "Status"
        ];
        worksheet.addRow(headerRow);

        const header = worksheet.getRow(1);
        header.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD966" },
          };
          cell.font = { bold: true };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        dataToExport.forEach((cycle) => {
          worksheet.addRow([
            cycle.orderCycleCode || "N/A",
            cycle.description || "N/A",
            cycle.location?.location_name || "N/A",
            cycle.createdBy?.username || "N/A",
            formatDateISO(cycle.orderdate),
            formatDateISO(cycle.deliveryDate),
            formatDateISO(cycle.createdDate),
            cycle.status || "N/A",
          ]);
        });

        worksheet.columns.forEach((column) => {
          column.width = column.header
            ? column.header.toString().length < 20
              ? 20
              : column.header.toString().length
            : 20;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "order_cycles.xlsx");
      };
    
    return (
      <div className="flex h-screen">
        {/* Main Content */}
        <div className="flex-1 p-8">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-green-700">Order Cycle</h1>
            {/* Conditionally render the Add Production Batch button */}
            {(userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User") && (
            <button
              onClick={onAddOrderCycleClick}
              className="bg-green-700 text-white px-4 py-2 rounded-lg"
            >
              Add Order Cycle
            </button>
            )}
          </div>
          <div className="bg-white p-4 rounded-lg shadow mb-8">
            <div className="flex justify-between mb-4 items-center">
            <div className="flex items-center flex-wrap gap-4">
              <select
                className="px-4 py-2 border border-gray-300 rounded-lg"
                value={selectedSearchField}
                onChange={(e) => setSelectedSearchField(e.target.value)}
              >
                <option value="orderCycleCode">Cycle Code</option>
                <option value="description">Description</option>
                <option value="createdBy">Created By</option>
                <option value="location">Location</option>
                <option value="orderdate">Order Date</option>
                <option value="deliveryDate">Delivery Date</option>
                <option value="status">Status</option>
              </select>

              <div className="relative">
                <input
                  type="text"
                  placeholder="Search Batch here"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="px-4 py-2 pl-10 border border-gray-300 rounded-lg w-full max-w-xs"
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
                </div>
              </div>
            </div>

            {/* Right Section: Download Excel */}
            <div>
              <button
                onClick={handleDownloadExcel}
                className="flex items-center bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
              >
                <FaDownload className="mr-2" />
                Download Excel
              </button>
            </div>
          </div>
            {/* Order Cycles Grid */}
            <Grid rows={filteredOrderCycles} columns={columns} getRowId={(row) => row.orderCycleCode}/>

          </div>
            {/* Popup for Order Cycle Details */}
            {selectedOrderCycle && !showCustomerSelectionPopup && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
              style={{ overflowY: "auto" }}
            >
              <div
                className="bg-white p-8 rounded-lg shadow-lg w-full md:w-2/3 lg:w-1/2 relative max-h-[90vh] overflow-y-auto"
                style={{ maxHeight: "90vh", overflowY: "auto" }}
              >
                <button
                  onClick={handleClosePopup}
                  className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 flex justify-center items-center rounded-sm hover:bg-red-700"
                >
                  &times;
                </button>
                <div className="w-full">
                  <h2 className="text-xl font-semibold mb-4">
                    {selectedOrderCycle.orderCycleCode}
                  </h2>

                  {/* Order Cycle Description */}
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Order Cycle Description
                    </label>
                    <input
                      type="text"
                      value={selectedOrderCycle.description || ''}
                      onChange={(e) => handleInputChange('description', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>

                  {/* Order Cycle Location */}
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Order Cycle Location
                    </label>
                    <input
                      type="text"
                      value={selectedOrderCycle.location}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      readOnly
                    />
                  </div>

                  {/* Order Cycle Created User */}
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Order Cycle Created User
                    </label>
                    <input
                      type="text"
                      value={selectedOrderCycle.createdBy}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      readOnly
                    />
                  </div>

                  {/* Order Cycle Created Date */}
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Order Cycle Created Date
                    </label>
                    <input
                      type="text"
                      value={selectedOrderCycle.createdDate}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      readOnly
                    />
                  </div>

                  {/* Status Dropdown */}
                  <div className="mb-4">
                    <label className="block text-gray-700">Status</label>
                    <select
                      value={selectedOrderCycle.status}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      onChange={(e) => {
                        setSelectedOrderCycle({
                          ...selectedOrderCycle,
                          status: e.target.value,
                        });
                        setIsEdited(true);
                      }
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Closed">Closed</option>
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">Delivery Date</label>
                    <input
                      type="date"
                      value={formatDateISO(selectedOrderCycle.deliveryDate)}
                      onChange={(e) => {
                          setSelectedOrderCycle({
                            ...selectedOrderCycle,
                            deliveryDate: e.target.value,
                          });
                          setIsEdited(true);
                        }
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-gray-700">Order Date</label>
                    <input
                      type="date"
                      value={formatDateISO(selectedOrderCycle.orderdate) || ""}
                        onChange={(e) => {
                          setSelectedOrderCycle({
                            ...selectedOrderCycle,
                            orderdate: e.target.value,
                          });
                          setIsEdited(true);
                        }
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  {/* Selected Orders Grid */}
                  <div className="mb-4">
                    <h3 className="text-lg font-semibold mb-2">
                      Order Cycle Selected Production Batch Details
                    </h3>
                    <div style={{ height: 400, width: "100%" }}>
                      <DataGrid
                        rows={selectedOrderCycle?.products || []} 
                        columns={[
                          { field: "product_code", headerName: "ID", width: 100, flex: 0.6, },
                          {
                            field: "product_image",
                            headerName: "Image",
                            width: 150,
                            flex: 1,
                            renderCell: (params) =>
                              params.row.product_image ? (
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}${params.row.product_image}`}
                                  alt="Product"
                                  className="h-16 w-16 object-cover rounded-md"
                                />
                              ) : (
                                "No Image"
                              ),
                          },
                          {
                            field: "product_name",
                            headerName: "Product Name",
                            width: 150,
                            flex: 1,
                          },
                          {
                            field: "aggregatedQuantity",
                            headerName: "Quantity",
                            width: 150,
                            flex: 1,
                            headerAlign: "right",
                            align: "right"
                          },
                          { 
                            field: "unit", 
                            headerName: "Units", 
                            flex: 1, 
                            headerAlign: "center", 
                            align: "center" 
                          },
                          {
                            field: "latestPrice",
                            headerName: "Price (LKR)",
                            width: 150,
                            flex: 1,
                            headerAlign: "right",
                            align: "right",
                            renderCell: (params) => `${new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)}`
                          }                          
                        ]}
                        pageSize={5}
                      />
                    </div>
                  </div>
                </div>
                {isEdited && (
                  <button
                    onClick={() => handleUpdateOrderCycle(selectedOrderCycle.orderCycleCode, selectedOrderCycle.description, selectedOrderCycle.status, selectedOrderCycle.deliveryDate, selectedOrderCycle.orderdate)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg mt-4"
                  >
                    Update Order Cycle
                  </button>
                )}
              </div>
            </div>
          )}
          
          {/* Include share button with updated click handler */}
          {/* Customer Selection Popup */}
          {showCustomerSelectionPopup && customers.length > 0 && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-3/4 lg:w-2/3 relative max-h-[90vh] overflow-y-auto">
                <button
                  onClick={handleCloseCustomerSelectionPopup}
                  className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 flex justify-center items-center rounded-sm hover:bg-red-700"
                >
                  &times;
                </button>
                <h3 className="text-lg font-semibold mb-4">Select Customers</h3>
                <div className="mb-4 flex items-center">
                <input
                  type="checkbox"
                  id="selectAll"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="mr-2 h-4 w-4"
                />
                <label htmlFor="selectAll" className="text-gray-700 font-medium cursor-pointer">
                  {selectAll ? "Unselect All" : "Select All"}
                </label>
              </div>
                <div style={{ height: "400px", width: "100%" }}>
                  <DataGrid
                    rows={customers}
                    columns={[
                      {
                        field: "select",
                        headerName: "Select",
                        width: 100,
                        renderCell: (params) => (
                          <input
                            type="checkbox"
                            checked={selectedCustomers.some(
                              (customer) =>
                                customer.customer_code ===
                                params.row.customer_code
                            )}
                            onChange={(e) =>
                              handleCustomerSelection(e, params.row)
                            }
                          />
                        ),
                      },
                      {
                        field: "customer_code",
                        headerName: "Customer Code",
                        width: 150,
                      },
                      { field: "customer_name", headerName: "Name", width: 200 },
                      {
                        field: "cus_mobileno",
                        headerName: "Mobile No",
                        width: 150,
                      },
                      { field: "cus_email", headerName: "Email", width: 200 },
                      { field: "customer_type", headerName: "Type", width: 100 },
                      {
                        field: "status",
                        headerName: "Customer Status",
                        width: 150,
                      },
                    ]}
                    pageSize={5}
                    checkboxSelection={false} // We're adding custom checkboxes
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    onClick={handleSendClick}
                    className="mt-4 bg-green-500 text-white px-4 py-2 rounded-lg flex items-center justify-center"
                  >
                    Send
                    <i className="fab fa-whatsapp ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  export default OrderCycle;